import { Component } from '@angular/core';
import { Observable } from 'rxjs';

import { SandboxDarkModeService } from '../../services/dark-mode.service';
import { SandboxMobileService } from '../../services';

@Component({
  selector: 'lms-approval-sandbox-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class SandboxMenuComponent {
  isDarkModeEnabled: boolean;
  isMobile$: Observable<boolean>;

  constructor(
    private darkModeService: SandboxDarkModeService,
    private sandboxMobileService: SandboxMobileService,
  ) {
    this.isDarkModeEnabled = this.darkModeService.isDarkModeEnabled;
    this.isMobile$ = this.sandboxMobileService.isMobileMode$;
  }

  toggleDarkMode(): void {
    this.darkModeService.toggleDarkMode();
    this.isDarkModeEnabled = this.darkModeService.isDarkModeEnabled;
  }

  updateMobileMode(value: boolean): void {
    this.sandboxMobileService.updateIsMobile(value);
  }
}
